export default __webpack_public_path__ + "static/color-interaction-states-light-594a975853726f780653f0aec7737268ce3757ba57eac1851b0c907b7f3649c4.png";